var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 23.6667C11.4531 23.6667 10.9998 23.2134 10.9998 22.6667V17.0801L10.0398 18.0401C9.65309 18.4267 9.01309 18.4267 8.62643 18.0401C8.23976 17.6534 8.23976 17.0134 8.62643 16.6267L11.2931 13.9601C11.5731 13.6801 12.0131 13.5867 12.3864 13.7467C12.7598 13.8934 12.9998 14.2667 12.9998 14.6667V22.6667C12.9998 23.2134 12.5464 23.6667 11.9998 23.6667Z",
    fill: "#DA57DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6668 18.3333C14.4134 18.3333 14.1601 18.2399 13.9601 18.0399L11.2934 15.3733C10.9068 14.9866 10.9068 14.3466 11.2934 13.9599C11.6801 13.5733 12.3201 13.5733 12.7068 13.9599L15.3734 16.6266C15.7601 17.0133 15.7601 17.6533 15.3734 18.0399C15.1734 18.2399 14.9201 18.3333 14.6668 18.3333Z",
    fill: "#DA57DF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 30.3334H11.9998C4.75984 30.3334 1.6665 27.2401 1.6665 20.0001V12.0001C1.6665 4.76008 4.75984 1.66675 11.9998 1.66675H18.6665C19.2132 1.66675 19.6665 2.12008 19.6665 2.66675C19.6665 3.21341 19.2132 3.66675 18.6665 3.66675H11.9998C5.85317 3.66675 3.6665 5.85341 3.6665 12.0001V20.0001C3.6665 26.1467 5.85317 28.3334 11.9998 28.3334H19.9998C26.1465 28.3334 28.3332 26.1467 28.3332 20.0001V13.3334C28.3332 12.7867 28.7865 12.3334 29.3332 12.3334C29.8798 12.3334 30.3332 12.7867 30.3332 13.3334V20.0001C30.3332 27.2401 27.2398 30.3334 19.9998 30.3334Z",
    fill: "#DA57DF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3332 14.3334H23.9998C19.4398 14.3334 17.6665 12.5601 17.6665 8.00007V2.66673C17.6665 2.26673 17.9065 1.8934 18.2798 1.74673C18.6532 1.58673 19.0798 1.68007 19.3732 1.96007L30.0398 12.6267C30.3198 12.9067 30.4132 13.3467 30.2532 13.7201C30.0932 14.0934 29.7332 14.3334 29.3332 14.3334ZM19.6665 5.08007V8.00007C19.6665 11.4401 20.5598 12.3334 23.9998 12.3334H26.9198L19.6665 5.08007Z",
    fill: "#DA57DF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.c166b609767c490e2ccfd6c6837433d9.svg";
export { ForwardRef as ReactComponent };